<template>
  <div>
		<Layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="my-4">
          <v-row class="bg-white mx-0">
            <v-col cols="6" class="text-end pt-4">
              <h1>{{ $t('area.rental_rate_of_market') }}</h1>
            </v-col>
            <v-col cols="6">
              <div style="max-width: 200px;">
                <v-menu
                  v-model="menuDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="$helper.datelabel(formData.date)"
                      :placeholder="$t('date')"
                      outlined
                      dense
                      hide-details
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="input-center"
                      prepend-inner-icon="mdi-calendar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.date"
                    no-title
                    locale="th"
                    @input="menuDate = false; initData()"
                    :header-date-format="$helper.headerDateFormat"
                    :year-format="$helper.yearFormat"
                    :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                    :allowed-dates="(date) => date <= new Date().toISOString().substr(0, 10)"
                  >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col cols="12" class="text-center pt-5 grey lighten-4">
              <div class="text-end">
                <v-btn @click="exportExcel()" class="blue white--text" :disabled="isLoading">
                  <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                  Export Excel
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>

        <v-data-table
          v-if="!isLoading"
          :headers="dataTable.header"
          :items="dataTable.data"
          class="elevation-1"
          :no-data-text="$t('noinfo')"
          :no-results-text="$t('no_matching_records_found')"
        >
        <template v-slot:item.marketName="{ item }">
          <div class="text-nowrap-table market-name">
            {{ item.marketName }}
          </div>
          </template>
          <template v-slot:item.areaCount="{ item }">
            {{ (item.areaCount || 0) | arabic }}
          </template>
          <template v-slot:item.areaOccupied="{ item }">
            {{ (item.areaOccupied || 0) | arabic }}
          </template>
          <template v-slot:item.areaVacant="{ item }">
            {{ ((item.areaCount - item.areaOccupied) || 0) | arabic }}
          </template>
          <template v-slot:item.areaOccupiedRate="{ item }">
            {{ (item.areaOccupiedRate || 0) | arabic }}%
          </template>
          <template v-slot:item.sizeCount="{ item }">
            {{ (item.sizeCount || 0) | arabic }}
          </template>
          <template v-slot:item.sizeOccupied="{ item }">
            {{ (item.sizeOccupied || 0) | arabic }}
          </template>
          <template v-slot:item.sizeVacant="{ item }">
            {{ ((item.sizeCount - item.sizeOccupied) || 0) | arabic }}
          </template>
          <template v-slot:item.sizeOccupiedRate="{ item }">
            {{ (item.sizeOccupiedRate || 0) | arabic }}%
          </template>
        </v-data-table>
        <v-card class="d-flex justify-center py-10" v-if="isLoading">
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </v-card>
			</template>
		</Layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
	</div>
</template>
<script>
import { mapState } from "vuex";
import Layout from "@/components/Layout.vue";
import { Market } from "../../classes"
import { ExportMarketReport } from "../../exports";
export default {
	components: {
		Layout,
	},
  data() {
    return {
			projectId: this.$route.params.projectId,
      project: null,
			isLoading: false,
			isError: false,
      formData: {
        date: this.$moment().format("YYYY-MM-DD"),
      },
      menuDate: false,
      dataTable: {
        header: [
          {
            text: this.$t('market.market'),
            width: "15%",
            value: "marketName",
            align:"center"
          },
          {
            text: this.$t('area.all_stall'),
            align: "right",
            value: "areaCount"
          },
					{
            text: this.$t('area.rented_stall'),
            align: "right",
            value: "areaOccupied"
          },
          {
            text: this.$t('area.empty_stall'),
            align: "right",
            value: "areaVacant"
          },
          {
            text: this.$t('area.rental_rate_of_stall'),
            align: "right",
            value: "areaOccupiedRate"
          },
          {
            text: this.$t('area.total_area'),
            align: "right",
            value: "sizeCount"
          },
          {
            text: this.$t('area.rented_area'),
            align: "right",
            value: "sizeOccupied"
          },
          {
            text: this.$t('area.empty_area'),
            align: "right",
            value: "sizeVacant"
          },
          {
            text: this.$t('area.rental_rate_of_area'),
            align: "right",
            value: "sizeOccupiedRate"
          },
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapState({
      sessionAdmins: (state) => state.admin.sessionAdmins,
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
  },
	created(){
		this.initData()
	},
	methods: {
		async initData(){
			this.isLoading = true
			try {
        this.dataTable.data = []
        
        if (this.admins && this.admins.length) {
          this.project = this.admins[0].project;
        } else if (this.employees && this.employees.length) {
          this.project = this.employees[0].project;
        } else {
          this.$router.push(`/notFound`);
        }

        let markets = await Market.getMarketByProject(this.projectId)
        let hashRate = await Market.getMarketsOccupancyRateInfo(
          markets.map(d => d.objectId),
          this.$moment(this.formData.date).endOf("day").toDate()
        )
        for(let market of markets){
          let obj = {
            market,
            marketName : market.name,
          }
          if(hashRate[market.objectId]){
            obj = {
              ...obj,
              ...hashRate[market.objectId]
            }
          }
          this.dataTable.data.push(obj)
        }
				this.isLoading = false
			} catch(error) {
				this.isLoading = false
				this.isError = true
			}
		},
    async exportExcel(){
      this.isLoading = true
      try{
        await ExportMarketReport.exportOccupancyRate(this.dataTable.data, this.formData.date)
        this.isLoading = false
      }catch(error){
        this.isLoading = false
        this.isError = true
      }
    }
	}
}
</script>
<style  lang="scss" scoped>
.v-data-table__expanded__content {
  box-shadow: 0 0 3px inset !important;
}
.text-nowrap-table.market-name{
  width: 100%;
}
</style>